module.exports = function () {
  return "\n\t\t<div class=\"poker-pot pot\">\n\t\t  <div class=\"pot-chip\">POT</div>\n\t\t  <div class=\"pot-value line2\"></div>\n\t\t  <div class=\"pot-units line3\"></div>\n\t\t</div>\n\t\t";
};